
// preform data
import isEmpty from 'lodash/isEmpty';

export const getLeadCities = state => state.leads.cities;
export const getLeadOccasions = state => state.leads.occasions;

//leadform Data
export const getLeadFormData = state => state.leads.leadFormData;
export const getPreLoadedLeadFormData = state => state.leads.preLoadedLeadFormData;
export const getPostVerificationFormData = state => state.leads.postVerificationFormData;
export const getLeadFormLoadingState = state => state.leads.isFetchingLeadForm;
export const getLeadFormCode = state => state.leads.leadFormCode;
export const getLeadTriggerFormCode = state => state.leads.leadFormTriggerCode;
export const getLeadFormVisibleState = state => state.leads.isLeadFormVisible;
export const getHomeLeadFormVisibleState = state => state.leads.isHomeLeadFormVisible;
export const getPreLeadFormButtonVisibleState = state => state.leads.isPreLeadFormButtonVisible;
export const getVenueSlideData = state => state.leads.venueSlideData;
export const getActiveTriggerSlide = state => state.leads.activeTriggerSlide;
export const getLeadFormVisibleCount = state => state.leads.leadformVisibleCount;
export const getSelectedLeadForm = state => state.newleadform.selectedLeadForm;
export const getEventPlanningState = state => state.leads.isPlanningEvent;
export const getEventRedirectionUrl = state => state.leads.eventSearchUrl;
export const getSelectedVenueForLeadForm = state => state.leads.selectedVenue;
export const getSelectedVenueStateForLeadForm = state => !isEmpty(state.leads.selectedVenue);
export const getSelectedLeadFormType = state => state.leads.leadFormType
export const getCurrentSelectedCity = state => state.leads.iscurrentcity


